import React from "react";
import styles from "./ContentPanel.less";
export const ContentPanel = (props) => {
    let styleToUse = styles.content;
    if (props.isMobile) {
        styleToUse = styles.contentMobile;
    }
    return (React.createElement("div", { className: styleToUse }, props.children));
};
